<template>
  <AlertWithDescription v-if="show" :type="type" class="mt-4">
    <p>
      {{ value }}
    </p>
  </AlertWithDescription>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import AlertWithDescription from './AlertWithDescription.vue'

export default {
  components: {
    AlertWithDescription,
  },

  data() {
    return {
      show: false,
    }
  },

  watch: {
    flash: function (value) {
      if (value) {
        this.show = true
      } else {
        this.show = false
      }
    },
  },

  mounted() {
    this.show = !!this.flash
  },

  computed: {
    flash() {
      let message =
        usePage().props.value.flash?.success ||
        usePage().props.value.flash?.error ||
        usePage().props.value.flash?.warning ||
        usePage().props.value.flash?.information
      if (message) return message + usePage().props.value.flash?.time
      return false
    },

    type() {
      if (usePage().props.value.flash?.success) return 'success'
      else if (usePage().props.value.flash?.error) return 'error'
      else if (usePage().props.value.flash?.warning) return 'warning'
      else if (usePage().props.value.flash?.information) return 'info'
    },

    value() {
      if (usePage().props.value.flash?.success)
        return usePage().props.value.flash?.success
      else if (usePage().props.value.flash?.error)
        return usePage().props.value.flash?.error
      else if (usePage().props.value.flash?.warning)
        return usePage().props.value.flash?.warning
      else if (usePage().props.value.flash?.information)
        return usePage().props.value.flash?.information
    },
  },
}
</script>
